import { useEffect, useState } from 'react'
import { Button, Header, Modal, Form } from 'semantic-ui-react'

import { Till } from '../models/till.model'
import { User } from '../models'
import { TillService, UserService } from '../services'
import { ErrorMessage, LoadingSpinner } from '.'

export function TillAssignationForm({ till, setAssignModalVisible }: { till: Till, setAssignModalVisible: Function }) {

    const [users, setUsers] = useState<User[]>([])
    const [loadingUsers, setLoadingUsers] = useState(true)

    const [userId, setUserId] = useState<number | undefined>()
    const [startDate, setStartDate] = useState('')
    const [endDate, setEndDate] = useState('')
    const [assigning, setAssigning] = useState(false)
    const [assignError, setAssignError] = useState(false)

    useEffect(() => {
        UserService.getUsersList('sup')
            .then(data => setUsers(data))
            .finally(() => setLoadingUsers(false))
    }, [])

    const handleSubmit = () => {
        if (!userId) return
        setAssigning(true)
        TillService.assignTill(till.id!, userId, startDate, endDate)
            .then(() => {

                setAssignModalVisible(false)

                window.location.reload()

            })
            .catch(() => setAssignError(true))
            .finally(() => setAssigning(false))
    }

    const userOptions = users
        .filter(u => u.permissions?.some(p => p.name === 'company_cashier'))
        .map(u => ({
            key: u.id,
            text: `${u.firstname} ${u.lastname}`,
            value: u.id
        }))

    return <Modal
        size='small'
        onClose={() => setAssignModalVisible(false)}
        onOpen={() => setAssignModalVisible(true)}
        open={true}>
        <Modal.Content>
            <Modal.Description>
                <Header as="h3">Assigner la caisse — {till.name}</Header>
                { assignError && <ErrorMessage errorText="Une erreur est survenue lors de l'assignation." /> }
                <br />
                { loadingUsers ? <LoadingSpinner /> :
                    <Form>
                        <Form.Select
                            fluid
                            label='Utilisateur'
                            options={userOptions}
                            placeholder='Choisir un utilisateur'
                            value={userId}
                            onChange={(_, { value }) => setUserId(value as number)}
                        />
                        <Form.Input
                            fluid
                            type='date'
                            label='Date de début'
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                        />
                        <Form.Input
                            fluid
                            type='date'
                            label='Date de fin'
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                        />
                    </Form>
                }
                <br />
            </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
            <Button color='black' onClick={() => setAssignModalVisible(false)}>Annuler</Button>
            <Button color='orange' content='Confirmer' onClick={handleSubmit} loading={assigning} disabled={!userId || !startDate || !endDate} />
        </Modal.Actions>
    </Modal>
}
